import React, { useState } from "react";
import { navigate } from "gatsby";
import PhotoCard from "../PhotoCard/PhotoCard";
import { FilterButton } from "../../components/FilterButton";
const styles = require("./CardFilter.module.scss");

const CardFilter = (props) => {
  const { members } = props;
  const [showKeyContacts, setShowKeyContacts] = useState(false);
  const [showSolutions, setshowSolutions] = useState(false);
  const [showExecutive, setShowExecutive] = useState(false);
  const [showAll, setShowAll] = useState(true);

  const sortedMembers = members.sort((a, b) =>
    a.surname.localeCompare(b.surname)
  );

  const groupedMembers = sortedMembers.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }

    acc[item.category].push(item);
    return acc;
  }, {});

  const handleClick = (buttonName) => {
    setShowKeyContacts(false);
    setshowSolutions(false);
    setShowExecutive(false);
    setShowAll(true);

    switch (buttonName) {
      case "keyContacts":
        setShowAll(showKeyContacts);
        setShowKeyContacts(!showKeyContacts);
        break;
      case "solutions":
        setShowAll(showSolutions);
        setshowSolutions(!showSolutions);
        break;
      case "executive":
        setShowAll(showExecutive);
        setShowExecutive(!showExecutive);
        break;
      case "all":
        setShowAll(true);
        break;
      default:
        return null;
    }
  };

  const noneSelected = !(showKeyContacts || showSolutions || showExecutive);

  return (
    <>
      <div className={styles.filter}>
        <ul>
          <li>
            <FilterButton
              selected={noneSelected ? true : showAll}
              click={() => handleClick("all")}
            >
              All categories
            </FilterButton>
          </li>
          {groupedMembers.ExecutiveCommittee ? (
            <li>
              <FilterButton
                selected={noneSelected ? false : showExecutive}
                click={() => handleClick("executive")}
              >
                Executive committee
              </FilterButton>
            </li>
          ) : null}
          {groupedMembers.KeyContact ? (
            <li>
              <FilterButton
                selected={noneSelected ? false : showKeyContacts}
                click={() => handleClick("keyContacts")}
              >
                Business development
              </FilterButton>
            </li>
          ) : null}
          {groupedMembers.SolutionsTeam ? (
            <li>
              <FilterButton
                selected={noneSelected ? false : showSolutions}
                click={() => handleClick("solutions")}
              >
                Solutions
              </FilterButton>
            </li>
          ) : null}
        </ul>
      </div>
      <div className={styles.gridWrapper}>
        {(showAll || showExecutive) && groupedMembers.ExecutiveCommittee ? (
          <>
            <h2 className={styles.sectionHeader}>Executive committee</h2>
            <div className={styles.container}>
              <div className="row">
                {groupedMembers.ExecutiveCommittee.map((member, index) => (
                  <div
                    key={member.surname + index}
                    className="col-12 col-md-6 col-lg-4 col-xl-3"
                  >
                    <PhotoCard
                      photo={member.photo}
                      name={`${member.firstname} ${member.surname}`}
                      jobTitle={member.jobTitle}
                      theme={"dawnPink"}
                      click={() => navigate(`./${member.slug}`)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : null}
        {(showAll || showKeyContacts) && groupedMembers.KeyContact ? (
          <>
            <h2 className={styles.sectionHeader}>Business development</h2>
            <div className={styles.container}>
              <div className="row">
                {groupedMembers.KeyContact.map((member, index) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 col-xl-3"
                    key={member.surname + index}
                  >
                    <PhotoCard
                      photo={member.photo}
                      name={`${member.firstname} ${member.surname}`}
                      jobTitle={member.jobTitle}
                      theme={"stoneGrey"}
                      click={() => navigate(`./${member.slug}`)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : null}

        {(showAll || showSolutions) && groupedMembers.SolutionsTeam ? (
          <>
            <h2 className={styles.sectionHeader}>Solutions</h2>
            <div className={styles.container}>
              <div className="row">
                {groupedMembers.SolutionsTeam.map((member, index) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 col-xl-3"
                    key={member.surname + index}
                  >
                    <PhotoCard
                      photo={member.photo}
                      name={`${member.firstname} ${member.surname}`}
                      jobTitle={member.jobTitle}
                      theme={"hiveYellow"}
                      click={() => navigate(`./${member.slug}`)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default CardFilter;
